import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  IntranetApiResponse,
  IntranetUiResponse,
  MaestroKey,
  MaestroOption,
} from '../models/intranet-maestro';
import { WebService } from './webservices.service';

export interface TipoVehiculoIconoCatalogo {
  idIcono: number;
  codigo: string | null;
  url: string | null;
  nombre: string;
  origen: 'APP' | 'SUBIDO';
}

@Injectable({
  providedIn: 'root',
})
export class IntranetMantenedoresService {
  private readonly baseUrl = `${environment.URL_WEBSERVICES}/intranet/seguridad/mantenedores`;

  constructor(private readonly webService: WebService) {}

  listar(key: MaestroKey): Observable<IntranetUiResponse<any[]>> {
    return this.webService
      .peticionPost(`${this.baseUrl}/${key}/listar`, {}, true)
      .pipe(map((response) => this.normalizarRespuesta<any[]>(response)));
  }

  guardar(key: MaestroKey, payload: Record<string, unknown>): Observable<IntranetUiResponse<any>> {
    return this.webService
      .peticionPost(`${this.baseUrl}/${key}/guardar`, payload, true)
      .pipe(map((response) => this.normalizarRespuesta<any>(response)));
  }

  listarIconosTipoVehiculo(): Observable<IntranetUiResponse<TipoVehiculoIconoCatalogo[]>> {
    return this.webService
      .peticionPost(`${this.baseUrl}/tipos-vehiculo/iconos/listar`, {}, true)
      .pipe(map((response) => this.normalizarRespuesta<TipoVehiculoIconoCatalogo[]>(response)));
  }

  subirIconoTipoVehiculo(file: File): Observable<IntranetUiResponse<TipoVehiculoIconoCatalogo>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.webService
      .peticionPostFormData(`${this.baseUrl}/tipos-vehiculo/icono`, formData, true)
      .pipe(map((response) => this.normalizarRespuesta<TipoVehiculoIconoCatalogo>(response)));
  }

  eliminar(key: MaestroKey, id: number): Observable<IntranetUiResponse<any>> {
    return this.webService
      .peticionPost(`${this.baseUrl}/${key}/eliminar`, { id }, true)
      .pipe(map((response) => this.normalizarRespuesta<any>(response)));
  }

  listarFlotasActivas(): Observable<IntranetUiResponse<MaestroOption[]>> {
    return this.webService
      .peticionPost(`${this.baseUrl}/flota/listar-activos`, {}, true)
      .pipe(map((response) => this.normalizarRespuesta<MaestroOption[]>(response)));
  }

  private normalizarRespuesta<T>(response: unknown): IntranetUiResponse<T> {
    const payload = (response ?? {}) as IntranetApiResponse<T>;

    if (typeof payload.isSuccess === 'boolean') {
      return {
        isSuccess: payload.isSuccess,
        message: payload.message ?? '',
        value: (payload.value as T | null) ?? null,
      };
    }

    return {
      isSuccess: payload.success ?? false,
      message: payload.message ?? '',
      value: (payload.data as T | null) ?? null,
    };
  }
}
